<template>
	<v-container class="content" fluid>
		<v-layout row>
			<v-flex grow>
				<h1 class="display-1 px-3">Betriebsdaten</h1>
			</v-flex>
		</v-layout>
		<v-snackbar
			v-model="snackbar"
			:timeout="10000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<v-progress-linear v-if="isLoading" color="accent" indeterminate></v-progress-linear>
		<v-tabs v-model="tab">
			<v-tab :key="0">Allgemein</v-tab>
			<v-tab :key="1">Benutzer</v-tab>
			<v-tab :key="2">Öffnungszeiten</v-tab>
			<v-tab-item :key="0" style="background-color: white">
				<v-form ref="form" v-model="valid">
					<v-container fluid>
						<v-layout row wrap>
							<v-flex xs12>
								<v-layout row align-center>
									<v-flex shrink class="mr-3">
										<input
											style="display: none"
											type="file"
											ref="upload"
											accept=".png, .jpg"
											v-on:change="uploadFiles($event, $event.target.files)"
										/>
										<v-btn
											@click.stop="$refs.upload.click()"
											class="ml-0 blexon-button"
											title="Logo hochladen."
										>
											<v-icon class="black--text">upload</v-icon>
										</v-btn>
									</v-flex>
									<v-flex shrink>
										<img
											style="height: 50px"
											onerror="this.style.display = 'none'"
											:src="getFertigerLogo()"
										/>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.name"
									label="Name"
									:readonly="true"
									title="Diese Angabe kann nur über die Helpdesk von Blexon geändert werden."
								>
								</v-text-field>
							</v-flex>

							<v-flex xs12>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.street"
									:rules="rules.required"
									label="Strasse"
									hint="Bitte definieren Sie hier die Strasse wo Kunden die Teile abholen können."
								>
								</v-text-field>
							</v-flex>

							<v-flex xs4>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.zip"
									:rules="rules.required"
									label="PLZ"
									hint="Bitte definieren Sie hier die PLZ wo Kunden die Teile abholen können."
								>
								</v-text-field>
							</v-flex>

							<v-flex xs8>
								<v-text-field
									autocomplete="shut-up-google"
									class="pl-3"
									v-model="fertiger.town"
									:rules="rules.required"
									label="Ort"
									hint="Bitte definieren Sie hier den Ort wo Kunden die Teile abholen können."
								>
								</v-text-field>
							</v-flex>

							<v-flex xs12>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.deliveryPhoneNumber"
									:rules="rules.required"
									label="Telefon Auslieferung / Spedition"
									hint="Bitte definieren Sie hier eine Telefonnummer für LKW Fahrer die Teile abholen."
								>
								</v-text-field>
							</v-flex>

							<v-flex xs12>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.technicalEMail"
									:rules="rules.emailRules"
									@blur="fertiger.technicalEMail = fertiger.technicalEMail.trim()"
									label="E-Mail für IT Probleme"
									hint="Diese E-Mail wird für Probleme mit dem Adapter / Import verwendet."
								></v-text-field>
							</v-flex>

							<v-flex xs12>
								An diese E-Mail-Adresse(n) werden Fertigungsdokumente per E-Mail
								gesendet, wenn diese Option im Fertigeradapter aktiviert ist.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in orderEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="orderEmails[index]"
											:rules="rules.optionalEmailRules"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="orderEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								An diese E-Mail-Adresse(n) werden Benachrichtigungen zu
								Stornierungen gesendet.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in avorEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="avorEmails[index]"
											:rules="
												isOnlyEmail('avor')
													? rules.emailRules
													: rules.optionalEmailRules
											"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="avorEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								An diese E-Mail-Adresse(n) werden Benachrichtigungen zu
								Beanstandungen / Tickets gesendet.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in ticketEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="ticketEmails[index]"
											:rules="
												isOnlyEmail('ticket')
													? rules.emailRules
													: rules.optionalEmailRules
											"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="ticketEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								An diese E-Mail-Adresse(n) werden Benachrichtigungen zu verspäteten
								Aufträgen gesendet.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in delayedOrderEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="delayedOrderEmails[index]"
											:rules="
												isOnlyEmail('delayed')
													? rules.emailRules
													: rules.optionalEmailRules
											"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="delayedOrderEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								Fertigungsdokumente werden ebenfalls an diese Adresse(n) gesendet,
								wenn sie pulverbeschichtete Teile enthalten.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in powderEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="powderEmails[index]"
											:rules="rules.optionalEmailRules"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="powderEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								Fertigungsdokumente werden ebenfalls an diese Adresse(n) gesendet,
								wenn sie feuerverzinkte Teile enthalten.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in hotDipZincEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="hotDipZincEmails[index]"
											:rules="rules.optionalEmailRules"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="hotDipZincEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12>
								Fertigungsdokumente werden ebenfalls an diese Adresse(n) gesendet,
								wenn sie galvanisch verzinkte Teile enthalten.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in galvanizeZincEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="galvanizeZincEmails[index]"
											:rules="rules.optionalEmailRules"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="galvanizeZincEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								Diese Personen werden benachrichtigt, wenn ein Auftrag ein
								Zertifikat verlangt.
								<v-layout row wrap align-center>
									<v-flex
										v-for="(email, index) in certificateEmails"
										:key="index"
										pr-1
										xs12
										md4
										lg3
									>
										<v-text-field
											autocomplete="shut-up-google"
											v-model="certificateEmails[index]"
											:rules="rules.optionalEmailRules"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs12 md4 lg3>
										<v-btn
											@click="certificateEmails.push('')"
											icon
											class="blexon-button"
											style="margin-bottom: 10px"
											><v-icon>add</v-icon></v-btn
										>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex xs12>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.generalEMail"
									:rules="rules.emailRules"
									@blur="fertiger.generalEMail = fertiger.generalEMail.trim()"
									label="Allgemeine E-Mail"
									hint="Diese E-Mail wird nur verwendet, wenn keine der oben genannten E-Mail Adressen sinnvoll sind."
								></v-text-field>
							</v-flex>

							<v-flex xs12>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.pickupLocation"
									:rules="rules.optionalStringMax74"
									@blur="
										() => {
											if (fertiger.pickupLocation) {
												fertiger.pickupLocation =
													fertiger.pickupLocation.trim();
											}
										}
									"
									label="Abholstandort"
									hint='Standort, wo Teile vom Transporteur abgeholt werden können (z.B. "Rampe 2")'
								></v-text-field>
							</v-flex>

							<v-flex xs12>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.pickupHint"
									:rules="rules.optionalStringMax74"
									@blur="
										() => {
											if (fertiger.pickupHint) {
												fertiger.pickupHint = fertiger.pickupHint.trim();
											}
										}
									"
									label="Abholbemerkung"
									hint='Bemerkung für Transporteur beim Abholen von Teilen (z.B. "Bei Hr. Muster melden")'
								></v-text-field>
							</v-flex>

							<v-flex xs12 v-show="isBlexonAdmin">
								<v-checkbox
									v-model="fertiger.isRampenabholungAvailable"
									label="Rampenabholung verfügbar"
								>
								</v-checkbox>
								<v-text-field
									autocomplete="shut-up-google"
									v-model="fertiger.maximumPressForce"
									label="Maximale Presskraft [kN]"
									hint="Hier die höchste Presskraft der verfügbaren Biegemaschinen eintragen."
								>
								</v-text-field>
							</v-flex>

							<v-flex xs12>
								<fieldset
									style="
										padding: 20px;
										border: 1px solid black;
										border-radius: 3px;
									"
								>
									<legend
										style="
											margin-left: -10px;
											padding-left: 10px;
											font-size: 12px;
											display: block;
											width: 250px;
										"
									>
										Minimale Anzahl Arbeitstage für Lieferung
									</legend>
									<span style="font-size: 12px">
										Blexon berechnet für jeden Auftrag die Bearbeitungszeiten
										und prüft ob Kapazität vorhanden ist. Wenn Kapazität
										vorhanden ist, bucht Blexon den Auftrag. Bei freier
										Kapazität kann das auch sehr kurzfristig eingeplant werden.
										Mit diesen Angaben definieren Sie, wie viele Arbeitstage ein
										Auftrag mindestens benötigt, auch wenn freie Kapazität
										vorhanden ist.<br />
										Wichtig: Je höher dieser Wert ist, umso weiter nach hinten
										schiebt sich der erste mögliche Liefertermin. Kunden neigen
										dazu, den frühesten Liefertermin zu wählen. Das kann dazu
										führen, dass andere Fertigungspartner eher Aufträge
										erhalten, wenn diese weniger Arbeitstage Mindestlieferzeit
										benötigen.
									</span>
									<v-layout row wrap mt-2 ma-0>
										<v-flex xs4>
											<v-text-field
												class="pr-3"
												autocomplete="shut-up-google"
												v-model="fertiger.minimumDeliveryTimeForLaserParts"
												:rules="rules.integerGreater0AndSmaller6"
												placeholder="Standardwert ist 4 Arbeitstage"
												title="Standardwert ist 4 Arbeitstage"
												label="Nur flache Teile im Auftrag"
												hint="Anzahl Arbeitstage wenn der Auftrag nur Teile ohne Abkantungen enthält"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs4>
											<v-text-field
												class="pr-3"
												autocomplete="shut-up-google"
												v-model="
													fertiger.additionalDeliveryTimeForUmformung
												"
												:rules="rules.integer0AndSmaller90"
												placeholder="Standardwert ist 0 Arbeitstage"
												title="Standardwert ist 0 Arbeitstage"
												label="Zusätzlich für Umformungen"
												hint="Anzahl zusätzliche Arbeitstage, falls Umformungen notwendig sind."
											>
											</v-text-field>
										</v-flex>
										<v-flex xs4>
											<v-text-field
												class="pr-3"
												autocomplete="shut-up-google"
												v-model="
													fertiger.additionalDeliveryTimeForBendParts
												"
												:rules="rules.integerGreater0AndSmaller4"
												placeholder="Standardwert ist 1 Arbeitstag"
												title="Standardwert ist 1 Arbeitstag"
												label="Zusätzlich für Biegeteile im Auftrag"
												hint="Anzahl zusätzliche Arbeitstage, wenn der Auftrag auch Teile mit Abkantungen enthält"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs4>
											<v-text-field
												class="pr-3"
												autocomplete="shut-up-google"
												v-model="
													fertiger.additionalDeliveryTimeForPressJoin
												"
												:rules="rules.integerGreater0AndSmaller4"
												placeholder="Standardwert ist 1 Arbeitstag"
												title="Standardwert ist 1 Arbeitstag"
												label="Zusätzlich für Teile mit Einpressungen im Auftrag"
												hint="Anzahl zusätzliche Arbeitstage, wenn der Auftrag auch Teile mit Einpressungen enthält"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs4>
											<v-text-field
												class="pr-3"
												autocomplete="shut-up-google"
												v-model="
													fertiger.additionalDeliveryTimeForWeldParts
												"
												:rules="rules.integer0AndSmaller10"
												placeholder="Standardwert ist 1 Arbeitstag"
												title="Standardwert ist 1 Arbeitstag"
												label="Zusätzlich für Schweißteile im Auftrag"
												hint="Anzahl zusätzliche Arbeitstage, wenn der Auftrag auch Teile mit Schweißungen enthält"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs4>
											<v-text-field
												class="pr-3"
												autocomplete="shut-up-google"
												v-model="
													fertiger.additionalDeliveryTimeForPowderCoating
												"
												:rules="rules.integer0AndSmaller25"
												placeholder="Standardwert ist 5 Arbeitstage"
												title="Standardwert ist 5 Arbeitstage"
												label="Zusätzlich für Pulverbeschichtung"
												hint="Anzahl zusätzliche Arbeitstage zum Pulverbeschichten von Teilen, wenn der Auftrag fertiggestellt ist"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs4>
											<v-text-field
												class="pr-3"
												autocomplete="shut-up-google"
												v-model="
													fertiger.additionalDeliveryTimeForZincCoating
												"
												:rules="rules.integer0AndSmaller25"
												placeholder="Standardwert ist 5 Arbeitstage"
												title="Standardwert ist 5 Arbeitstage"
												label="Zusätzlich für Verzinken"
												hint="Anzahl zusätzliche Arbeitstage zum Verzinken von Teilen, wenn der Auftrag fertiggestellt ist"
											>
											</v-text-field>
										</v-flex>
									</v-layout>
								</fieldset>
							</v-flex>
							<v-flex>
								<v-btn
									class="ml-0 mt-4 blexon-button"
									:loading="isLoading"
									:disabled="!valid"
									@click="save"
								>
									Speichern
								</v-btn>
							</v-flex>
						</v-layout>
					</v-container>
				</v-form>
			</v-tab-item>
			<v-tab-item :key="1">
				<v-data-table
					style="table-layout: fixed"
					:headers="userHeaders"
					:items="fertiger.logins"
					hide-actions
					class="elevation-1"
				>
					<template slot="items" slot-scope="props">
						<tr>
							<td>
								{{ props.item.username }}
							</td>
							<td>
								<v-checkbox
									style="
										width: 34px;
										height: 34px;
										margin: auto;
										padding-top: 5px;
									"
									:disabled="
										getUsername() === props.item.username ||
										isExternalServiceProvider(props.item)
									"
									v-model="props.item.canEditProgrammingData"
									@change="updateProgrammingRight(props.item)"
								>
								</v-checkbox>
							</td>
							<td>
								<v-checkbox
									style="
										width: 34px;
										height: 34px;
										margin: auto;
										padding-top: 5px;
									"
									:disabled="
										getUsername() === props.item.username ||
										isExternalServiceProvider(props.item)
									"
									v-model="props.item.canEditComplains"
									@change="updateTicketRight(props.item)"
								>
								</v-checkbox>
							</td>
							<td v-if="fertiger.makesManualOffers">
								<v-checkbox
									style="
										width: 34px;
										height: 34px;
										margin: auto;
										padding-top: 5px;
									"
									:disabled="getUsername() === props.item.username"
									v-model="props.item.canEditOffers"
									@change="updateUserEditManualOfferRight(props.item)"
								>
								</v-checkbox>
							</td>
							<td>
								<v-checkbox
									style="
										width: 34px;
										height: 34px;
										margin: auto;
										padding-top: 5px;
									"
									:disabled="getUsername() === props.item.username"
									v-model="props.item.isExternalPowderCoater"
									@change="updateIsExternalPowderCoater(props.item)"
								>
								</v-checkbox>
							</td>
							<td>
								<v-checkbox
									style="
										width: 34px;
										height: 34px;
										margin: auto;
										padding-top: 5px;
									"
									:disabled="getUsername() === props.item.username"
									v-model="props.item.isExternalHotDipZincCoater"
									@change="updateIsExternalHotDipZincCoater(props.item)"
								>
								</v-checkbox>
							</td>
							<td>
								<v-checkbox
									style="
										width: 34px;
										height: 34px;
										margin: auto;
										padding-top: 5px;
									"
									:disabled="getUsername() === props.item.username"
									v-model="props.item.isExternalGalvanizeZincCoater"
									@change="updateIsExternalGalvanizeZincCoater(props.item)"
								>
								</v-checkbox>
							</td>
							<td style="text-align: center">
								<v-icon
									color="accent"
									:disabled="getUsername() === props.item.username"
									title="Benutzer ohne Sicherheitsabfrage löschen"
									@click="deleteUser(props.item)"
								>
									delete
								</v-icon>
							</td>
						</tr>
					</template>
				</v-data-table>
				<v-dialog v-model="newLoginDialog" persistent max-width="600px">
					<v-btn slot="activator" class="mt-3" v-if="isFertigerAdmin">
						Neues Login
					</v-btn>
					<v-card>
						<v-card-title>
							<span class="headline">Neues Login</span>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-md pa-0>
								<v-layout wrap>
									<v-flex xs12>
										<v-autocomplete
											:search-input.sync="search"
											:loading="isLoading"
											:items="users"
											hide-no-data
											@change="setUsername"
											placeholder="E-Mail eingeben um Suche zu starten"
											label="Neuer Benutzer"
										>
										</v-autocomplete>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn flat @click.native="newLoginDialog = false">Schliessen</v-btn>
							<v-btn
								class="blexon-button"
								flat
								:disabled="username == null || username == ''"
								@click.native="addLogin(fertiger)"
							>
								Speichern
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-tab-item>
			<v-tab-item :key="2" style="background-color: white">
				<edit-opening-hours
					v-if="fertiger && fertiger.openingHours"
					:fertigerId="fertigerId"
					:openingHours="fertiger.openingHours.slots"
					@saved="
						() => {
							setSnackbarText('Öffnungszeiten gespeichert.');
						}
					"
					@failedToSave="
						() => {
							setSnackbarText('Öffnungszeiten konnten nicht gespeichert werden.');
						}
					"
				></edit-opening-hours>
			</v-tab-item>
		</v-tabs>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";
import EditFertigerOpeningHours from "./editFertigerOpeningHours.vue";

export default {
	components: {
		"edit-opening-hours": EditFertigerOpeningHours,
	},

	props: {
		fertigerId: Number | String,
	},
	data() {
		return {
			tab: 0,
			newLoginDialog: false,
			queryTerm: "",
			users: [],
			username: null,
			isBlexonAdmin: false,
			delayedOrderEmails: [],
			powderEmails: [],
			hotDipZincEmails: [],
			galvanizeZincEmails: [],
			certificateEmails: [],
			ticketEmails: [],
			avorEmails: [],
			orderEmails: [],
			snackbar: false,
			snackbarText: "",
			fertiger: {},
			isLoading: false,
			valid: false,
			rules: {
				optionalEmailRules: [
					(v) =>
						!v ||
						/^[^@\s;]+@[^@\s;]+\.[^@\s;]+$/.test(v) ||
						"Muss eine gültige E-Mail Adresse sein. ",
				],
				emailRules: [
					(v) => !!v || "E-Mail ist erforderlich",
					(v) =>
						/^[^@\s;]+@[^@\s;]+\.[^@\s;]+$/.test(v) ||
						"Muss eine gültige E-Mail Adresse sein",
				],
				required: [
					(v) => !!v || "Angabe erforderlich",
					(v) => !v || v.length <= 50 || "Darf nicht länger als 50 Zeichen sein",
				],
				optionalStringMax74: [
					(v) => v == null || v.length <= 74 || "Darf nicht länger als 74 Zeichen sein",
				],
				integerGreater0AndSmaller10: [
					(v) =>
						(v !== null &&
							v !== undefined &&
							v !== "" &&
							v == parseInt(v) &&
							v > 0 &&
							v <= 10) ||
						"Muss eine Zahl zwischen 1 und 10 sein",
				],
				integerGreater0AndSmaller6: [
					(v) =>
						(v !== null &&
							v !== undefined &&
							v !== "" &&
							v == parseInt(v) &&
							v > 0 &&
							v < 6) ||
						"Muss eine Zahl zwischen 1 und 5 sein",
				],
				integerGreater0AndSmaller4: [
					(v) =>
						(v !== null &&
							v !== undefined &&
							v !== "" &&
							v == parseInt(v) &&
							v > 0 &&
							v < 4) ||
						"Muss eine Zahl zwischen 1 und 3 sein",
				],
				integer0AndSmaller10: [
					(v) =>
						(v !== null &&
							v !== undefined &&
							v !== "" &&
							v == parseInt(v) &&
							v >= 0 &&
							v <= 10) ||
						"Muss eine Zahl zwischen 0 und 10 sein",
				],
				integer0AndSmaller25: [
					(v) =>
						(v !== null &&
							v !== undefined &&
							v !== "" &&
							v == parseInt(v) &&
							v >= 0 &&
							v <= 25) ||
						"Muss eine Zahl zwischen 0 und 25 sein",
				],
				integer0AndSmaller4: [
					(v) =>
						(v !== null &&
							v !== undefined &&
							v !== "" &&
							v == parseInt(v) &&
							v >= 0 &&
							v < 4) ||
						"Muss eine Zahl zwischen 0 und 3 sein",
				],
				integer0AndSmaller90: [
					(v) =>
						(v !== null &&
							v !== undefined &&
							v !== "" &&
							v == parseInt(v) &&
							v >= 0 &&
							v < 90) ||
						"Muss eine Zahl zwischen 0 und 90 sein",
				],
			},
		};
	},
	async mounted() {
		this.setAdmin();
		await this.loadFertiger();
		this.validateFields();
	},
	computed: {
		search: {
			get() {
				return this.queryTerm;
			},

			set(searchInput) {
				if (searchInput && this.queryTerm !== searchInput) {
					this.queryTerm = searchInput;
					if (this.queryTerm.length > 2) {
						this.searchUsers();
					}
				}
			},
		},
		userHeaders: {
			get() {
				const headers = [
					{
						text: "Benutzername",
						align: "left",
						sortable: false,
						width: "5px",
					},
					{
						text: "Kann Einstellungen bearbeiten",
						align: "center",
						sortable: false,
						width: "5px",
					},
					{
						text: "Kann Beanstandungen bearbeiten",
						align: "center",
						sortable: false,
						width: "5px",
					},
				];
				if (this.fertiger.makesManualOffers) {
					headers.push({
						text: "Kann Angebote bearbeiten",
						align: "center",
						sortable: false,
						width: "5px",
					});
				}
				headers.push({
					text: "Ist externer Pulverbeschichter",
					align: "center",
					sortable: false,
					width: "5px",
				});
				headers.push({
					text: "Ist externer Feuerverzinker",
					align: "center",
					sortable: false,
					width: "5px",
				});
				headers.push({
					text: "Ist externer galvanischer Verzinker",
					align: "center",
					sortable: false,
					width: "5px",
				});
				headers.push({
					text: "Benutzer entfernen",
					align: "center",
					sortable: false,
					width: "5px",
				});
				return headers;
			},
		},
		isFertigerAdmin() {
			return this.$store.getters.currentFertiger(this.$route.params.fertigerId)
				.canManuallyTransmit;
		},
	},
	methods: {
		validateFields() {
			this.$nextTick(() => {
				this.$refs.form.validate();
			});
		},
		setUsername(user) {
			this.username = user;
		},
		getFertigerLogo() {
			return `${process.env.VUE_APP_SERVER_URL}api/fertiger/getlogo?fertigerId=${this.fertigerId}`;
		},
		async searchUsers() {
			try {
				if (this.isLoading) {
					return;
				}
				this.isLoading = true;
				var response = await httpClient().get(
					`api/Fertiger/GetUsers?searchTerm=${this.queryTerm}`
				);
				this.users = response.data;
			} finally {
				this.isLoading = false;
			}
		},
		async addLogin(fertiger) {
			try {
				this.dataLoading = true;
				await httpClient().post(
					`api/Fertiger/AddLogin?fertigerId=${this.fertigerId}&username=${this.username}`
				);
				this.newLoginDialog = false;
				await this.loadFertiger();
				this.setSnackbarText("Benutzer erfolgreich registriert.");
			} catch (err) {
				this.setSnackbarText(
					`Fehler beim Registrieren. Bitte prüfen Sie, ob ein Benutzer mit der Adresse '${this.username}' wirklich registriert ist.`
				);
			} finally {
				this.dataLoading = false;
			}
		},
		async loadFertiger() {
			try {
				this.isLoading = true;
				let response = await httpClient().get(
					`api/Fertiger/EditFertiger?id=${this.fertigerId}`
				);
				this.fertiger = response.data;
				this.delayedOrderEmails = this.fertiger.delayedOrderEMail.split(";");
				this.powderEmails = this.fertiger.powderCoaterEmail.split(";");
				this.hotDipZincEmails = this.fertiger.hotDipZincCoaterEmail.split(";");
				this.galvanizeZincEmails = this.fertiger.galvanizeZincCoaterEmail.split(";");
				this.certificateEmails = this.fertiger.certificateEmails.split(";");
				this.ticketEmails = this.fertiger.ticketEMail.split(";");
				this.avorEmails = this.fertiger.avorEMail.split(";");
				this.orderEmails = this.fertiger.orderEMail.split(";");
			} catch (err) {
				console.log(err);
			} finally {
				this.isLoading = false;
			}
		},
		async save() {
			try {
				this.isLoading = true;
				this.delayedOrderEmails = this.delayedOrderEmails.filter((mail) =>
					this.isValidEmail(mail)
				);
				this.fertiger.delayedOrderEMail = this.delayedOrderEmails.join(";");
				this.powderEmails = this.powderEmails.filter((mail) => this.isValidEmail(mail));
				this.fertiger.powderCoaterEmail = this.powderEmails.join(";");
				this.hotDipZincEmails = this.hotDipZincEmails.filter((mail) =>
					this.isValidEmail(mail)
				);
				this.fertiger.hotDipZincCoaterEmail = this.hotDipZincEmails.join(";");
				this.galvanizeZincEmails = this.galvanizeZincEmails.filter((mail) =>
					this.isValidEmail(mail)
				);
				this.fertiger.galvanizeZincCoaterEmail = this.galvanizeZincEmails.join(";");
				this.certificateEmails = this.certificateEmails.filter((mail) =>
					this.isValidEmail(mail)
				);
				this.fertiger.certificateEmails = this.certificateEmails.join(";");
				this.ticketEmails = this.ticketEmails.filter((mail) => this.isValidEmail(mail));
				this.fertiger.ticketEMail = this.ticketEmails.join(";");
				this.avorEmails = this.avorEmails.filter((mail) => this.isValidEmail(mail));
				this.fertiger.avorEMail = this.avorEmails.join(";");
				this.orderEmails = this.orderEmails.filter((mail) => this.isValidEmail(mail));
				this.fertiger.orderEMail = this.orderEmails.join(";");
				await httpClient().post(`api/Fertiger/EditFertiger`, this.fertiger);
				this.setSnackbarText("Daten erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Speichern der Daten.");
			} finally {
				this.isLoading = false;
			}
		},
		async updateProgrammingRight(user) {
			try {
				this.isLoading = true;
				console.log("updating programming right");
				await httpClient().post(
					`api/Fertiger/updateUserProgrammingRight?fertigerId=${this.fertigerId}&username=${user.username}&canEdit=${user.canEditProgrammingData}`,
					null
				);
				this.setSnackbarText("Daten erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Speichern der Daten.");
			} finally {
				this.isLoading = false;
			}
		},
		async updateTicketRight(user) {
			try {
				this.isLoading = true;
				await httpClient().post(
					`api/Fertiger/updateUserTicketRight?fertigerId=${this.fertigerId}&username=${user.username}&canEdit=${user.canEditComplains}`,
					null
				);
				this.setSnackbarText("Daten erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Speichern der Daten.");
			} finally {
				this.isLoading = false;
			}
		},
		async updateUserEditManualOfferRight(user) {
			try {
				this.isLoading = true;
				await httpClient().post(
					`api/Fertiger/updateUserEditManualOfferRight?fertigerId=${this.fertigerId}&username=${user.username}&canEditOffers=${user.canEditOffers}`,
					null
				);
				this.setSnackbarText("Daten erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Speichern der Daten.");
			} finally {
				this.isLoading = false;
			}
		},
		async updateIsExternalPowderCoater(user) {
			try {
				this.isLoading = true;
				await httpClient().post(
					`api/Fertiger/updateUserIsPowderCoater?fertigerId=${this.fertigerId}&username=${user.username}&isPowderCoater=${user.isExternalPowderCoater}`,
					null
				);
				if (user.isExternalPowderCoater) {
					await this.updateProgrammingAndTicketRights(user);
				}
				this.setSnackbarText("Daten erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Speichern der Daten.");
			} finally {
				this.isLoading = false;
			}
		},
		async updateIsExternalHotDipZincCoater(user) {
			try {
				this.isLoading = true;
				await httpClient().post(
					`api/Fertiger/UpdateUserIsHotDipZincCoater?fertigerId=${this.fertigerId}&username=${user.username}&isCoater=${user.isExternalHotDipZincCoater}`,
					null
				);
				if (user.isExternalHotDipZincCoater) {
					await this.updateProgrammingAndTicketRights(user);
				}
				this.setSnackbarText("Daten erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Speichern der Daten.");
			} finally {
				this.isLoading = false;
			}
		},
		async updateIsExternalGalvanizeZincCoater(user) {
			try {
				this.isLoading = true;
				await httpClient().post(
					`api/Fertiger/UpdateUserIsGalvanizeZincCoater?fertigerId=${this.fertigerId}&username=${user.username}&isCoater=${user.isExternalGalvanizeZincCoater}`,
					null
				);
				if (user.isExternalGalvanizeZincCoater) {
					await this.updateProgrammingAndTicketRights(user);
				}
				this.setSnackbarText("Daten erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Speichern der Daten.");
			} finally {
				this.isLoading = false;
			}
		},
		async updateProgrammingAndTicketRights(user) {
			if (user.canEditProgrammingData) {
				user.canEditProgrammingData = false;
				await this.updateProgrammingRight(user);
			}
			if (user.canEditComplains) {
				user.canEditComplains = false;
				await this.updateTicketRight(user);
			}
		},
		async deleteUser(user) {
			try {
				this.isLoading = true;
				await httpClient().delete(
					`api/Fertiger/deleteUser?fertigerId=${this.fertigerId}&username=${user.username}`
				);
				await this.loadFertiger();
				this.setSnackbarText("Benutzer erfolgreich gelöscht.");
			} catch (err) {
				this.setSnackbarText("Fehler beim Löschen des Benutzers.");
			} finally {
				this.isLoading = false;
			}
		},
		uploadFiles(event, files) {
			if (files.length !== 1) {
				return;
			}
			for (const file of files) {
				const data = new FormData();
				data.append("file", file);
				const config = {
					header: {
						"Content-Type": "multipart/form-data",
					},
				};

				httpClient()
					.post(`api/fertiger/UploadLogo?fertigerId=${this.fertigerId}`, data, config)
					.catch((error) => {
						console.log("Fehler beim Upload");
					});
			}
		},
		getUsername() {
			return this.$store.state.oidc.user.profile.email.toLowerCase();
		},
		async setAdmin() {
			const result = await httpClient().get("api/Capacity/IsUserAdmin");
			this.isBlexonAdmin = result.data;
		},
		/**
		 * Sets the text in the snackbar and shows it.
		 */
		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
		isValidEmail(emailText) {
			if (emailText == undefined) {
				return false;
			}
			if (emailText.length < 3) {
				return false;
			}
			if (!/^[^@\s;]+@[^@\s;]+\.[^@\s;]+$/.test(emailText)) {
				return false;
			}
			return true;
		},
		isExternalServiceProvider(user) {
			return (
				user.isExternalPowderCoater ||
				user.isExternalHotDipZincCoater ||
				user.isExternalGalvanizeZincCoater
			);
		},
		isOnlyEmail(category) {
			let validEmails = [];
			switch (category) {
				case "avor":
					validEmails = this.avorEmails.filter((e) => this.isValidEmail(e));
					break;
				case "ticket":
					validEmails = this.ticketEmails.filter((e) => this.isValidEmail(e));
					break;
				case "delayed":
					validEmails = this.delayedOrderEmails.filter((e) => this.isValidEmail(e));
					break;
				default:
					console.log("Unknown email category.");
			}
			return validEmails.length === 0;
		},
	},
};
</script>

<style scoped>
/* .theme--light.v-input--selection-controls.v-input--is-disabled .v-icon {
    color: grey !important;
} */
</style>
